<div *ngIf="loading"
     class="container-loading-content is-flex is-justify-content-center is-align-items-center">
  <div class="loading"></div>
</div>
<p *ngIf="!isAccess()">
  <span>Keine Berechtigung</span>
</p>
<div *ngIf="!loading && isAccess()">

  <div *ngIf="!loading && customerInvoices.length==0">
    <p>Keine Einträge vorhanden.</p>
  </div>
  <div *ngIf="customerInvoices.length > 0">
    <div class="columns is-multiline is-hidden-touch" *ngIf="!loading">
      <div class="column is-3-mobile is-2-tablet">
        <b>Datum</b>
      </div>
      <div class="column is-3-mobile is-2-tablet">
        <b>Nr.</b>
      </div>
      <div class="column is-3 has-text-right">
        <b>Gesamtbetrag Brutto</b>
      </div>
      <div class="column is-3-mobile is-2-tablet has-text-right">
        <b>Offener Betrag</b>
      </div>
    </div>
    <div class="columns" *ngFor="let item of customerInvoices; let i = index;">
      <div class="column is-3-mobile is-2-tablet">
        {{item.date | date:'dd.MM.yyyy'}}
      </div>
      <div class="column is-3-mobile is-2-tablet">
        {{item.uniqueNumber}}
      </div>
      <div class="column is-3">
        {{NumberFormat(item.amount, currency)}}
      </div>
      <div class="column is-3-mobile is-2-tablet has-text-right">
        <span *ngIf="item.openAmount > 0">{{NumberFormat(item.openAmount, currency)}}</span>
        <span *ngIf="item.openAmount == 0">-</span>
      </div>
      <div class="column is-12-mobile is-3-tablet">
        <a (click)="downloadInvoice(item.id)">Rechnung herunterladen</a>
      </div>
    </div>
      <div class="my-3">
          <iw-shop-core-paginator [start]="start" [limit]="limit" [length]="customerInvoices.length" (onChange)="changePage($event)"></iw-shop-core-paginator>
      </div>

  </div>
</div>
